import { rem } from "polished";
import styled from "styled-components";

export const FLOATING_MENU_SIZE = 48;

const BlockOutlineFloatingOptionButton = styled.button`
  background: none;
  border: none;
  height: ${rem(FLOATING_MENU_SIZE)};
  cursor: pointer;

  &:focus-visible {
    outline: ${rem(2)} solid #fff;
    outline-offset: ${rem(-4)};
  }
`;

const BlockOutlineFloatingOptionsWrapper = styled.div`
  background: #9444fb;
  display: grid;
  ${BlockOutlineFloatingOptionButton}:not(:last-of-type) {
    border-bottom: ${rem(2)} solid #fff;
  }
`;

export { BlockOutlineFloatingOptionsWrapper, BlockOutlineFloatingOptionButton };
